/**
 * @voltxampere/ui — TDA7297 stereo audio amplifier (Sprint 45-2, placeholder)
 *
 * PLACEHOLDER. Stereo dual-channel amplifier — şu anki stamp tek
 * channel `opamp` üzerinden gösterir; gerçek dual channel +
 * BTL bridge mode Sprint 47+'da.
 *
 * Reference: ST TDA7297 — Multiwatt-15. Stereo Hi-Fi audio amp,
 * V_supply 6.5-18 V, 2×15 W @ 4 Ω (THD 1%), gain 32 dB internal
 * (no external feedback). PC speaker + portable boombox + small
 * tuner amp + multimedia projector audio.
 *
 *   Default mapping → opamp schemaType:
 *     openLoopGain = 40        (32 dB gain ≈ 40)
 *     poleFrequency = 25       (1 MHz GBW / 40 estimate)
 *     saturationVoltage = 14   (V_supply 18V için close-to-rail)
 *
 * Engine zero-diff invariant honored — canonical `opamp` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const audioTda7297 = {
    id: "tda7297",
    nameTr: "TDA7297 (Stereo Audio Amp 2×15W, MW-15, placeholder)",
    nameEn: "TDA7297 (Stereo Audio Amp 2×15W, MW-15, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "TDA7297",
    schemaType: "opamp",
    defaultParams: { openLoopGain: 40, poleFrequency: 25, saturationVoltage: 14 },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=audio-tda7297.js.map